<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div
      class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex"
    >
      <dark-Toggler class="d-none d-lg-block" />

      <b
        :class="tempo_logout_tempo_ < 60 ? 'text-danger' : ''"
        id="tempo_logout_"
        >{{ tempo_logout_ }}</b
      >

      <span class="system-version" @click="openModalVersao">
        {{ code }}
      </span>

      <!-- Modal Notas de Versão -->
      <b-modal
        id="modalVersao"
        title="Notas da Versão"
        centered
        v-model="modalVisible"
        size="lg"
      >
        <div class="table-responsive">
          <table class="table table-striped text-center">
            <thead>
              <tr>
                <th>Título</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <pre style="font-size: 14px">{{ summary }}</pre>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <template #modal-footer>
          <b-button variant="secondary" @click="closeModalVersao"
            >Fechar</b-button
          >
        </template>
      </b-modal>
    </div>

    <div class="d-sm-flex d-none user-nav mr-2">
      <h6 class="text-right user-name font-weight-bolder mb-0">
        <span style="font-size: 12pt; line-height: 14pt">{{ user.name }}</span
        ><br />
        <span style="font-size: 10pt; line-height: 6pt">{{ user.cargo }}</span
        ><br />
        <span v-if="unidade" class="unit-name">{{ unidade.nome }}</span>
      </h6>
    </div>
    <div class="btn btn-danger btn-navbar px-1" @click="socorro()">
      <i class="fas fa-exclamation-triangle"></i>
      <span class="btn-navbar-label">Socorro</span>
    </div>
    <div
      class="btn btn-primary btn-navbar px-1 ml-1"
      @click="showFinalizaModal = true"
      v-show="[4, 5, 7].includes($store.state.user.perfil_id)"
    >
      <i class="fas fa-key"></i>
      <span class="btn-navbar-label">Fechar dia</span>
    </div>
    <div class="btn btn-info btn-navbar px-1 ml-1" @click="showModal = true">
      <i class="fas fa-clipboard-list"></i>
      <span class="btn-navbar-label">Localizar senha</span>
    </div>
    <b-navbar-nav class="nav align-items-center ml-auto ml-1">
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="user.photo"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>
        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="myProfile()"
        >
          <feather-icon size="16" icon="UserIcon" class="mr-50" />
          <span>Meu Perfil</span>
        </b-dropdown-item>

        <b-dropdown-divider />

        <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
          <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
          <span>Sair</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>

    <b-modal
      id="finaliza"
      v-model="showFinalizaModal"
      @hide="clearConfirmacao_"
      size="sm"
      title="Reiniciar senhas"
      hide-footer
      centered
    >
      <div class="modal-body p-1">
        <div class="text-center">
          <h5>Tem certeza que deseja reiniciar as senhas?</h5>
        </div>
        <div class="col-12 text-right p-0 mt-1">
          <button class="btn btn-sm btn-secondary" @click="closeFinalizaModal">
            Cancelar
          </button>
          <button class="btn btn-sm btn-primary ml-1" @click="resetSenhas()">
            Fechar
          </button>
        </div>
      </div>
    </b-modal>

    <!-- Modal Localizar Senhas -->
    <b-modal
      id="mostraSenhas"
      v-model="showModal"
      @hide="clearPesquisa_"
      size="lg"
      title="Localizar senha"
      hide-footer
      centered
    >
      <div class="modal-body p-1">
        <div class="row">
          <div class="col-9">
            {{ configuracao.tipo_pessoa }}
            <input
              type="text"
              class="form-control"
              v-model="pesquisa_.pessoa"
            />
          </div>
          <div class="col-3">
            Senha
            <input type="text" class="form-control" v-model="pesquisa_.senha" />
          </div>
        </div>
        <div class="col-12 text-right p-0 mt-1">
          <button class="btn btn-sm btn-secondary" @click="closeModal">
            Cancelar
          </button>
          <button class="btn btn-sm btn-primary ml-1" @click="getSenhas_()">
            Pesquisar
          </button>
        </div>
      </div>
      <div
        class="modal-footer text-center p-0 d-flex align-items-center justify-content-center"
        style="overflow-x: auto"
      >
        <div class="w-100" v-if="senhas_.length">
          <table class="table table-bordered table-striped">
            <thead>
              <th class="align-middle text-center">Nome</th>
              <th class="align-middle text-center">Senha</th>
              <th class="align-middle text-center">Setor</th>
              <th class="align-middle text-center">Entrada no setor</th>
              <th class="align-middle text-center">Tempo em fila</th>
              <th class="align-middle text-center">Status</th>
              <th class="align-middle text-center">Atendido por</th>
              <th class="align-middle text-center">Ações</th>
            </thead>
            <tbody v-for="(senha_, index) in senhas_" :key="index">
              <td class="align-middle text-center">
                {{ senha_.pessoa ? senha_.pessoa.nome : "Não identificado" }}
              </td>
              <td class="align-middle text-center">
                {{ senha_.prefixo + senha_.senha }}
              </td>
              <td class="align-middle text-center">
                <span class="badge badge-secondary">
                  {{
                    senha_.atendimento_setor
                      ? senha_.atendimento_setor[0].setor.nome
                      : "Não disponível"
                  }}<br />
                  {{
                    senha_.atendimento_setor
                      ? senha_.atendimento_setor[0].local_id
                        ? "(" + senha_.atendimento_setor[0].local.nome + ")"
                        : ""
                      : ""
                  }}
                </span>
              </td>
              <td class="align-middle text-center">
                {{
                  senha_.atendimento_setor
                    ? senha_.atendimento_setor[0].data_entrada_f
                    : "Não disponível"
                }}
              </td>
              <td
                class="align-middle text-center"
                v-if="senha_.atendimento_setor"
              >
                <span
                  class="d-flex justify-content-center align-items-center badge badge-secondary"
                >
                  {{
                    Math.floor(
                      senha_.atendimento_setor[0].data_entrada_diff / 60
                    ).toString() + " Minutos"
                  }}
                </span>
              </td>
              <td class="align-middle text-center">
                <span
                  :class="
                    'badge badge-' +
                    (senha_.atendimento_setor
                      ? senha_.atendimento_setor[0].status_badge
                      : 'secondary')
                  "
                >
                  {{
                    senha_.atendimento_setor
                      ? senha_.atendimento_setor[0].status_text
                      : "Não disponível"
                  }}
                </span>
              </td>
              <td class="align-middle text-center">
                <span
                  :class="
                    'badge badge-' +
                    (senha_.atendimento_setor
                      ? senha_.atendimento_setor[0].user_id
                        ? 'primary'
                        : 'secondary'
                      : 'secondary')
                  "
                >
                  {{
                    senha_.atendimento_setor
                      ? senha_.atendimento_setor[0].user_id
                        ? senha_.atendimento_setor[0].user.name
                        : "Não atendido"
                      : "Não disponível"
                  }}
                </span>
              </td>
              <td class="align-middle text-center">
                <div class="d-flex">
                  <button
                    class="btn btn-crud btn-primary"
                    @click="getSetores_(index)"
                    title="Trocar setor"
                  >
                    <i class="fas fa-exchange-alt" style="font-size: 9pt"></i>
                  </button>
                  <button
                    class="btn btn-crud btn-danger"
                    @click="resetSenha_(index)"
                    v-if="senha_.atendimento_setor[0].user_id"
                    title="Remover usuário do atendimento"
                  >
                    <i class="fas fa-user-minus" style="font-size: 8pt"></i>
                  </button>
                </div>
              </td>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row px-1 mb-3" v-if="setores_.length">
        <div class="col-12">
          <h6>
            Alterar setor da senha {{ senhaTroca_.prefixo + senhaTroca_.senha }}
          </h6>
        </div>
        <div class="col-12">
          <label>Setor</label>
          <v-select
            :options="setores_"
            :reduce="(setores_) => setores_.id"
            :label="'nome'"
            v-model="setorTroca_"
            class="vselect"
            :append-to-body="true"
            :calculate-position="dropdownPosition"
          ></v-select>
          <div class="col-12 p-0 text-right">
            <button class="btn btn-primary btn-sm mt-1" @click="alteraSetor_()">
              Alterar
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BLink,
  BNavbarNav,
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
  BModal,
  BButton,
} from "bootstrap-vue";
import DarkToggler from "@core/layouts/components/app-navbar/components/DarkToggler.vue";
import router from "@/router";
import { Alert } from "bootstrap";
import vSelect from "vue-select";
import Cookies from "js-cookie";

export default {
  data() {
    return {
      authenticated: false,
      disabled: true,
      user: {},
      tempo_logout_tempo_: 301,
      tempo_logout_: "",
      configuracao: [],
      setores_: [],
      senhaTroca_: {},
      setorTroca_: 0,
      senhas_: {},
      pesquisa_: {
        pessoa: null,
        senha: "",
      },
      showModal: false,
      showFinalizaModal: false,
      versoes: null,
      code: "",
      summary: "",
      modalVisible: false,
      unidade: null,
    };
  },
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    BModal,
    BButton,
    // Navbar Components
    DarkToggler,
    vSelect,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    dropdownPosition(dropdownList, component, { width, top, left }) {
      dropdownList.style.zIndex = 9999;
      dropdownList.style.width = width;
      dropdownList.style.top = top;
      dropdownList.style.left = left;
    },
    openModalVersao() {
      this.$bvModal.show("modalVersao"); // Mostra o modal usando o Bootstrap-Vue
    },
    closeModalVersao() {
      this.$bvModal.hide("modalVersao"); // Oculta o modal usando o Bootstrap-Vue
    },
    async getVersoes() {
      const api = this.$store.state.api + "versoes/";

      try {
        const response = await axios.get(api);

        if (!response || !response.data) {
          console.error("Resposta da API inválida:", response);
          return;
        }

        const versoes = response.data.data;
        const versao = versoes[versoes.length - 1]; // <-- pega sempre o último

        const newVersao = versao.code;

        const savedVersao = Cookies.get("current_versao");
        if (savedVersao && savedVersao !== newVersao) {
          alert(
            "Uma nova versão está disponível. Por favor, atualize o sistema."
          );
        }

        if (savedVersao !== newVersao) {
          this.saveVersaoInCookie(newVersao);
        }

        this.versoes = versao;
        this.code = versao.code; // <-- era response.data.code (undefined)
        this.summary = versao.summary; // <-- era response.data.summary (undefined)
      } catch (error) {
        console.error("Erro ao obter versões:", error);
        if (error.response && error.response.data) {
          this.$message(null, error.response.data, "error");
        }
      }
    },
    saveVersaoInCookie(versaoCode) {
      Cookies.set("current_versao", versaoCode, { expires: 7, path: "/" });
    },
    checkVersao() {
      const savedVersao = Cookies.get("current_versao");
      if (savedVersao && savedVersao !== this.versoes.code) {
        alert(
          "Uma nova versão está disponível. Por favor, atualize o navegador."
        );
      }
    },
    updateVersaoCookie() {
      this.getVersoes();
    },
    logout: function () {
      let self = this;
      let api = this.$store.state.api + "logout";
      const logoutChamador =
        self.$store.state.api + "logout_chamador/" + self.$store.state.user.id;

      axios
        .post(logoutChamador)
        .then((response) => {
          axios
            .post(api)
            .then((response) => {
              localStorage.removeItem("token");

              self.$router.push({ path: "/login" });

              setTimeout(() => {
                location.reload();
              }, 500);
            })
            .catch((error) => {
              this.errors = error.response.data.errors;
              this.$message("Erro", "Erro ao realizar logout", "error");
            });
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    socorro: function () {
      let self = this;
      let api = this.$store.state.api + "panicos";

      if (!self.$store.state.user.local) {
        self.$store.state.user.local = 0;
      }

      self.$http
        .post(api, {
          usuario_id: self.$store.state.user.id,
          local_id: self.$store.state.user.local,
          atendido: 0,
        })
        .then((response) => {
          this.$message(
            null,
            "Mantenha calma, a ajuda está a caminho",
            "warning"
          );
        })
        .catch((error) => {
          this.$message("Erro", "Falha ao solicitar ajuda", "error");
        });
    },
    myProfile: function () {
      const self = this;

      router.push("my-profile");
    },
    resetSenhas: function () {
      let self = this;
      let api = this.$store.state.api + "reset-senhas";

      this.$loading(true);
      this.showFinalizaModal = false;

      self.$http
        .post(api, [])
        .then(() => {
          this.showFinalizaModal = false;
          this.$loading(false);
          this.$router.push("/");
          this.$message(
            null,
            "Contagem de senhas zerada com sucesso!!!",
            "success"
          );
        })
        .catch((error) => {
          this.$loading(false);
          let msg = "Falha ao reiniciar o dia";
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            msg = error.response.data.message;
          }
          this.$message("Erro", msg, "error");
        });
    },
    closeFinalizaModal() {
      this.showFinalizaModal = false;
    },
    clearConfirmacao_: function () {},
    getConfiguracoes_: function () {
      let self = this;
      let api = this.$store.state.api + "configuracoes";

      self.$http
        .get(api)
        .then((response) => {
          self.configuracao = response.data.data[0];

          self.tempo_logout_tempo_ = self.configuracao.tempo_logout;

          self.inactivityClock();
        })
        .catch((error) => {
          this.$message("Erro", "Nenhuma configuração ativa", "error");
        });
    },
    inactivityClock: function () {
      const self = this;

      if (!self.configuracao.tempo_logout) return;

      const COOKIE_KEY = "sigap_ultima_atividade";

      // Funções auxiliares de cookie
      const setCookie = function (valor) {
        const expira = new Date(
          Date.now() + self.configuracao.tempo_logout * 2 * 1000
        );
        document.cookie = `${COOKIE_KEY}=${valor}; expires=${expira.toUTCString()}; path=/; SameSite=Strict`;
      };

      const getCookie = function () {
        const match = document.cookie.match(
          new RegExp("(?:^|; )" + COOKIE_KEY + "=([^;]*)")
        );
        return match ? parseInt(match[1]) : null;
      };

      // Sempre reseta o cookie ao iniciar (nova sessão/login)
      setCookie(Date.now());

      const atualizaTimer = function () {
        const ultimaAtividade = getCookie() || Date.now();
        const decorrido = Math.floor((Date.now() - ultimaAtividade) / 1000);
        self.tempo_logout_tempo_ = Math.max(
          0,
          self.configuracao.tempo_logout - decorrido
        );

        self.tempo_logout_ =
          Math.trunc(self.tempo_logout_tempo_ / 60)
            .toString()
            .padStart(2, "0") +
          ":" +
          (self.tempo_logout_tempo_ % 60).toString().padStart(2, "0");

        if (self.tempo_logout_tempo_ < 10) {
          $("#tempo_logout_").hide();
          setTimeout(function () {
            $("#tempo_logout_").show();
          }, 300);
        }

        if (self.tempo_logout_tempo_ === 0) {
          clearInterval(intervalo);
          document.cookie = `${COOKIE_KEY}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
          self.logout();
        }
      };

      // Roda imediatamente para não mostrar valor antigo por 1 segundo
      atualizaTimer();
      let intervalo = setInterval(atualizaTimer, 1000);

      // Reseta o cookie ao interagir
      const resetTimer = function () {
        setCookie(Date.now());
      };

      $(document).on("click keypress mousemove scroll", resetTimer);
    },
    getSenhas_: function () {
      let self = this;
      let api = this.$store.state.api + "procura-senha";

      axios
        .post(api, self.pesquisa_)
        .then((response) => {
          self.senhas_ = response.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getSetores_: function (index) {
      let self = this;
      let api = this.$store.state.api + "setores?ativo=1&paginated=false";

      axios
        .get(api, self.pesquisa_)
        .then((response) => {
          self.senhaTroca_ = self.senhas_[index];
          self.senhas_ = {};

          self.setores_ = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    alteraSetor_: function () {
      const self = this;
      const api = self.$store.state.api + "troca-setor/";

      if (self.senhaTroca_.atendimento_setor) {
        let atendimento_setor = self.senhaTroca_.atendimento_setor[0];

        const senhaNumero = self.senhaTroca_.prefixo + self.senhaTroca_.senha;
        const setorAnterior = atendimento_setor.setor
          ? atendimento_setor.setor.nome
          : "Setor anterior";
        const novoSetorId = self.setorTroca_;
        const novoSetorNome =
          self.setores_.find((setor) => setor.id === self.setorTroca_)?.nome ||
          "Novo setor";

        self.$loading(true);

        atendimento_setor.status = 1;
        atendimento_setor.user_id = 0;
        atendimento_setor.setor_id = self.setorTroca_;
        atendimento_setor.local_id = null;

        axios
          .post(api, atendimento_setor)
          .then(() => {
            self.$message(
              "Setor Alterado com Sucesso!",
              `Senha ${senhaNumero} foi transferida de "${setorAnterior}" para "${novoSetorNome}"`,
              "success"
            );

            self.clearPesquisa_();
            self.showModal = false;
            self.$loading(false);

            self.$root.$emit("senha-setor-alterado", {
              atendimento_setor_id: atendimento_setor.id,
              senha_numero: senhaNumero,
              setor_anterior: setorAnterior,
              novo_setor_id: novoSetorId,
              novo_setor_nome: novoSetorNome,
              acao: "troca_setor",
            });
          })
          .catch((error) => {
            self.$loading(false);
            self.$message(null, error.response.data, "error");
          });
      }
    },
    clearPesquisa_: function () {
      const self = this;

      self.setores_ = [];
      self.setorTroca_ = 0;
      self.senhaTroca_ = {};
      self.senhas_ = {};
      self.pesquisa_ = {
        pessoa: null,
        senha: "",
      };
    },
    resetSenha_: function (index) {
      const self = this;
      let atendimento_setor = self.senhas_[index].atendimento_setor[0];
      const api =
        self.$store.state.api + "atendimento_setor/" + atendimento_setor.id;

      self.$loading(true);

      atendimento_setor._method = "PUT";
      atendimento_setor.status = 1;
      atendimento_setor.user_id = 0;
      atendimento_setor.data_inicio = null;
      atendimento_setor.local_id = null;

      axios
        .post(api, atendimento_setor)
        .then(() => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );

          self.clearPesquisa_();

          $("#mostraSenhas").modal("hide");

          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getUnidade: function () {
      const self = this;
      const api = self.$store.state.api + "unidades";

      axios
        .get(api)
        .then((response) => {
          self.unidade = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    closeModal() {
      this.showModal = false;
    },
  },
  mounted() {
    const self = this;

    self.getConfiguracoes_();
    self.getVersoes();
    self.getUnidade();
    setTimeout(function () {
      self.user = self.$store.state.user;

      if (self.user.password_expired == 1) {
        $("#modalChangePassword").modal({
          backdrop: "static",
          keyboard: false,
        });
      }
    }, 100);
    this.versaoUpdateInterval = setInterval(() => {
      this.updateVersaoCookie();
    }, 3600000);
  },
  beforeDestroy() {
    clearInterval(this.versaoUpdateInterval);
  },
};
</script>
<style scoped>
.system-version {
  font-weight: bold;
}

.unit-name {
  font-size: 8pt;
  font-weight: 500;
  color: #6e6b7b;
  line-height: 8pt;
  letter-spacing: 0.3px;
}

.btn-navbar {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
}

.btn-navbar-label {
  display: inline-block;
  max-width: 0;
  overflow: hidden;
  opacity: 0;
  margin-left: 0;
  transition: max-width 0.25s ease, opacity 0.25s ease, margin-left 0.25s ease;
}

.btn-navbar:hover .btn-navbar-label {
  max-width: 120px;
  opacity: 1;
  margin-left: 0.25rem;
}
</style>